// src/components/DownloadsPage.jsx
import React, { useEffect, useState } from "react";
import MenuLayout from "./MenuLayout";
import "../styles/DownloadsPage.css";
import { getDownloadItems } from "../api/downloads";

const cards = [
  {
    id: 1,
    title: "اکسپرت Forex99 مبتنی بر استراتژی",
    subtitle: "شکست کانال های keltner",
    desc: "متن نمونه برای دانلود اول؛ توضیح کوتاه درباره اکسپرت و کاربری آن.",
  },
  {
    id: 2,
    title: "ربات مدیریت ریسک",
    subtitle: "تنظیم پویا در معاملات",
    desc: "فایل شامل ابزار مدیریت ریسک و گزارش روزانه برای معامله‌گران.",
  },
  {
    id: 3,
    title: "اندیکاتور حجم بازار",
    subtitle: "نمایش لحظه‌ای حجم",
    desc: "اندیکاتوری جهت تحلیل حجم و جریان سفارشات با تنظیمات ساده.",
  },
  {
    id: 4,
    title: "پکیج آموزشی پرایش اکشن",
    subtitle: "تمرین و مثال‌های عملی",
    desc: "محتوای آموزشی جهت یادگیری سریع پرایش اکشن به همراه تمرین.",
  },
];

const resolveMediaUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `https://api.touchprop.com${url}`;
};

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString("fa-IR");
};

const handleDownload = (event, fileUrl) => {
  if (!fileUrl) return;
  const target = event?.target;
  if (!target?.closest) return;
  const button = target.closest(".dw__download-btn");
  if (!button) return;
  window.open(fileUrl, "_blank", "noopener");
};

const DownloadsPage = () => {
  const [downloads, setDownloads] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDownloads = async () => {
      try {
        const data = await getDownloadItems();
        setDownloads(Array.isArray(data) ? data : []);
        setError("");
      } catch (err) {
        setDownloads([]);
        setError(err.message || "Failed to load downloads.");
      } finally {
        setLoading(false);
      }
    };
    fetchDownloads();
  }, []);

  const items = loading ? cards : downloads;
  const showEmpty = !loading && !error && downloads.length === 0;
  return (
    <MenuLayout>
      <div className="dw">
        <header className="dw__header">
          <h1 className="dw__title">دانلودها</h1>
          <p className="dw__subtitle">آخرین ابزارها و فایل‌های آماده برای دانلود.</p>
        </header>

        <div className="dw__grid">
          {items.map((item) => {
            const imageUrl = resolveMediaUrl(item.image) || "/images/dw.png";
            const fileUrl = resolveMediaUrl(item.file);
            const subtitle = item.subtitle || formatDate(item.created_at);
            const description = item.description || item.desc;
            return (
              <div
                className="dw__card"
                key={item.id || item.title}
                onClick={(event) => handleDownload(event, fileUrl)}
              >
                <div className="dw__image">
                  <img src={imageUrl} alt={item.title || "download"} />
                </div>
                <div className="dw__body">
                  <div className="dw__card-title">{item.title}</div>
                  {subtitle && <div className="dw__card-subtitle">{subtitle}</div>}
                  {description && <p className="dw__card-desc">{description}</p>}
                </div>
                <button className="dw__download-btn">دانلود</button>
              </div>
            );
          })}
          {showEmpty && <div className="dw__empty">No downloads found.</div>}
          {error && <div className="dw__empty">{error}</div>}
        </div>
      </div>
    </MenuLayout>
  );
};

export default DownloadsPage;
